/* eslint-disable no-template-curly-in-string */
import {
  getSocketData,
  sendSocketData,
} from "../redux/auctions/auctions.actions";
import { store } from "../redux/store";
import CryptoJS from "crypto-js";

/* const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_KEY);
const iv = CryptoJS.enc.Utf8.parse("1234567890123456");

export function encrypt(text) {
  const encrypted = CryptoJS.AES.encrypt(text, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  // return encrypted.toString();
  const ivCiphertext = iv.clone().concat(encrypted.ciphertext);
  return CryptoJS.enc.Base64.stringify(ivCiphertext);
}

export function decrypt(base64Input) {
  const rawData = CryptoJS.enc.Base64.parse(base64Input);

  // Extract IV and Ciphertext
  const extractedIV = CryptoJS.lib.WordArray.create(
    rawData.words.slice(0, 4),
    16
  ); // 16 bytes IV
  const ciphertext = CryptoJS.lib.WordArray.create(
    rawData.words.slice(4),
    rawData.sigBytes - 16
  );

  const decrypted = CryptoJS.AES.decrypt({ ciphertext: ciphertext }, key, {
    iv: extractedIV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
} */
export const setBackgroundBlur = (amount: string) => {
  const root = document.getElementById("root");
  if (root !== null) root.style.filter = `blur(${amount})`;
};

export const reduceArray = (
  firstKey: any,
  secondKey: any,
  oldArray: any[],
  firstKeyResult: string = "id",
  secondKeyResult: string = "name"
) => {
  const modifiedArray = oldArray.reduce((acc: any[], obj: any) => {
    acc.push({
      [firstKeyResult]: obj[firstKey],
      [secondKeyResult]: obj[secondKey],
    });
    return acc;
  }, []);
  return modifiedArray;
};

export const onFilterClick = (activeTab: number) => {
  const params = {
    crop_id: store.getState().common.selectedCrop,
    branch_id: store.getState().common.selectedBranch,
    hub_id: store.getState().auction.selectedHubs,
    variety_id: store.getState().auction.selectedVarieties,
    claim_type: store.getState().auction.selectedClaims,
    ...(activeTab <= 2 && { auction_type: store.getState().common.selectedAuctionType })
  };
  const extendedParams = {
    ...params,
    start_date: store.getState().auction.startDate,
    end_date: store.getState().auction.endDate,
  }
  const orderParams = {
    crop_id: [store.getState().common.selectedCrop],
    branch_id: [store.getState().common.selectedBranch],
    hub_id: store.getState().auction.selectedHubs,
    variety_id: store.getState().auction.selectedVarieties,
    claim_type: store.getState().auction.selectedClaims,
    delivery_status: store.getState().common.selectedDeliveryStatus && [store.getState().common.selectedDeliveryStatus],
    po_status: store.getState().common.selectedPoStatus && [store.getState().common.selectedPoStatus],
    payment_status: store.getState().common.selectedPayment && [store.getState().common.selectedPayment],
    vendor_code: store.getState().common.vendorCode,
    po_number: store.getState().common.poNumber,
    // sauda_type: store.getState().common.selectedSaudaType && [store.getState().common.selectedSaudaType],
    start_date: store.getState().auction.startDate,
    end_date: store.getState().auction.endDate,
  };
  switch (activeTab) {
    case 0:
      store.dispatch(sendSocketData("trader_active_auction_event", params));
      store.dispatch(getSocketData("trader_active_auctions"));
      store.dispatch(sendSocketData("trader_upcoming_auction_event", params));
      store.dispatch(getSocketData("trader_upcoming_auctions"));
      store.dispatch(sendSocketData("my_bids_event", extendedParams));
      store.dispatch(getSocketData("my_bids"));
      break;
    case 1:
      store.dispatch(sendSocketData("trader_active_auction_event", params));
      store.dispatch(getSocketData("trader_active_auctions"));
      break;
    case 2:
      store.dispatch(sendSocketData("trader_upcoming_auction_event", params));
      store.dispatch(getSocketData("trader_upcoming_auctions"));
      break;
    case 3:
      store.dispatch(sendSocketData("my_bids_event", extendedParams));
      store.dispatch(getSocketData("my_bids"));
      break;
    case 4:
      store.dispatch(sendSocketData("my_wins_event", extendedParams));
      store.dispatch(getSocketData("my_wins"));
      break;
    case 5:
      // store.dispatch(sendSocketData("my_order_event", orderParams));
      store.dispatch(sendSocketData("offline_order_event", orderParams));
      store.dispatch(getSocketData("my_orders"));
      break;
    default:
      break;
  }
};

export const toSnakeCase = (str: string) =>
  str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

export const formatString = (str: string) =>
  str
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

export const passwordValidator = (_, value) => {
  if (value && value.trim().length < 8) {
    return Promise.reject("Password must be at least 8 characters.");
  } else if (value && !value.match(/[a-z]/)) {
    return Promise.reject(
      "Password must contain at least one lowercase letter."
    );
  } else if (value && !value.match(/[A-Z]/)) {
    return Promise.reject(
      "Password must contain at least one uppercase letter."
    );
  } else if (value && !value.match(/[0-9]/)) {
    return Promise.reject("Password must contain at least one digit.");
  } else if (value && !value.match(/[^a-zA-Z0-9]/)) {
    return Promise.reject(
      "Password must contain at least one special character."
    );
  } else return Promise.resolve();
};

export const commonValidator = (_, value) => {
  if (value && value.trim().length === 0) {
    return Promise.reject("Please enter valid ${label}");
  }
  return Promise.resolve();
};

export const textValidator = (_, value) => {
  if (value && new RegExp(/[^a-zA-Z0-9\s,.]/g).test(value)) {
    return Promise.reject("Special Character are not allowed");
  }
  return commonValidator(_, value);
};

export const emailValidator = (_, value) => {
  if (value && !new RegExp(/\S+@\S+\.\S+/).test(value)) {
    return Promise.reject("Please enter valid E-mail address");
  }
  return commonValidator(_, value);
};

export const phoneValidator = (_, value) => {
  if (value && !new RegExp(/^[6789]\d{9}$/).test(value)) {
    return Promise.reject("Please enter valid phone number");
  }
  return commonValidator(_, value);
};

export const postCodeValidator = (_, value) => {
  if (value && !new RegExp(/^\d{6}$/).test(value)) {
    return Promise.reject("Please enter valid postal code");
  }
  return commonValidator(_, value);
};
